import { login, loginNodeRED, infoByEmail, getSystemParameters} from "./user";
import { uploadExcel,deleteTransformedExcel,getAllProcessedExcelFiles,createMapping,getRegistrations, convertSelected  } from "./excel";
import { getAllRegistrations,getAllDestinations, deleteRegistration, GetMaterials, GetUnitOfMeasurements, GetOrigins, saveRegistration, GetCollectionMethods , GetWastestreams, getUser} from "./registration";

export const dataService = {
    login,
    infoByEmail,
    loginNodeRED,
    uploadExcel,
    convertSelected,
    deleteTransformedExcel,
    getAllProcessedExcelFiles,
    getAllDestinations,
    GetCollectionMethods,
    getRegistrations,
    createMapping,
    getAllRegistrations,
    deleteRegistration,
    saveRegistration,
    GetMaterials,
    GetUnitOfMeasurements,
    GetOrigins,
    GetWastestreams,
    getUser,
    getSystemParameters
};

